import { animate, animateChild, query, style, transition, trigger } from '@angular/animations';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IonSpinner, Platform } from '@ionic/angular/standalone';
import { SlipComponentInfo } from '../student-slip-item-choices-modal/student-slip-item-choices-modal.store';
import { ItemChoicesComponentInfo, PaymentProgress, PaymentState, PaymentStatus } from '../student-slip-modal.store';
import { StudentSlipPaymentInfoComponent } from '../student-slip-payment/student-slip-payment-info/student-slip-payment-info.component';
import { StudentSlipItemChoicesPaymentHybridComponent } from './student-slip-item-choices-payment-hybrid/student-slip-item-choices-payment-hybrid.component';
import { StudentSlipItemChoicesPaymentWebComponent } from './student-slip-item-choices-payment-web/student-slip-item-choices-payment-web.component';

@Component({
  selector: 'app-student-slip-item-choices-payment',
  templateUrl: './student-slip-item-choices-payment.component.html',
  styleUrls: ['./student-slip-item-choices-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonSpinner, StudentSlipPaymentInfoComponent, StudentSlipItemChoicesPaymentHybridComponent, StudentSlipItemChoicesPaymentWebComponent],
  animations: [
    trigger('slideUpFadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(15%)' }),
        animate('200ms ease-in', style({ opacity: 1, transform: 'translateY(-3%)' })),
        animate('150ms ease-in', style({ opacity: 1, transform: 'translateY(0%)' }))
      ])
    ]),
    trigger('slideUpFadeInWithChild', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(15%)' }),
        animate('200ms ease-in', style({ opacity: 1, transform: 'translateY(-3%)' })),
        animate('150ms ease-in', style({ opacity: 1, transform: 'translateY(0%)' })),
        query('@delayedSlideUpFadeIn', animateChild())
      ])
    ]),
    trigger('delayedSlideUpFadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(15%)' }),
        animate('400ms 100ms ease-in', style({ opacity: 1, transform: 'translateY(0%)' }))
      ])
    ])
  ]
})
export class StudentSlipItemChoicesPaymentComponent {
  @Input() slipComponentInfo: SlipComponentInfo;
  @Input() itemChoicesComponentInfo: ItemChoicesComponentInfo;
  @Input() paymentProgress: PaymentProgress;
  @Input() reservationExpiresOn: string;
  @Output() paymentMethodUpdated = new EventEmitter<string>();
  @Output() paymentStatusChange = new EventEmitter<PaymentStatus>();
  @Output() requestReservationRefresh = new EventEmitter<void>();

  PaymentState = PaymentState;

  constructor(private platform: Platform) {}

  get isHybrid(): boolean {
    return this.platform.is('hybrid');
  }

  get showForm(): boolean {
    return (
      this.paymentProgress.state === PaymentState.Initialised &&
      (this.itemChoicesComponentInfo.status === 'pending' ||
        this.itemChoicesComponentInfo.status === 'in-progress' ||
        (this.itemChoicesComponentInfo.status === 'done' && this.itemChoicesComponentInfo.balance > 0))
    );
  }

  onPaymentStatusChanged(status): void {
    this.paymentStatusChange.emit(status);
  }
  onPaymentMethodUpdated(paymentMethod): void {
    this.paymentMethodUpdated.emit(paymentMethod);
  }
}
